const state = {
  loading: false,
  centered: false,
  darkMode: JSON.parse(localStorage.darkMode ?? false),
  latestVersion: null
}

export default state
